import { useEffect, useRef, useState } from "react";

/** Default delay before a dim or cue shows. */
export const DIM_DELAY_MS = 200;
/** The Action plan's cue delay: no skeleton or dim under 300 ms (motion bar, Leo 10-31). */
export const CUE_MS = 300;
/** A cue that shows stays this long, so it never blinks (RT r5: no cue episode under 200 ms). */
export const CUE_MIN_MS = 200;

/** True only once `flag` has held for `delayMs`; false the moment it drops, or `minMs` after it turned on. */
export function useDelayedFlag(
  flag: boolean,
  delayMs = DIM_DELAY_MS,
  minMs = 0,
): boolean {
  const [held, setHeld] = useState(false);
  const since = useRef(0);
  useEffect(() => {
    if (flag) {
      if (held) return undefined;
      const id = window.setTimeout(() => {
        since.current = Date.now();
        setHeld(true);
      }, delayMs);
      return () => window.clearTimeout(id);
    }
    if (!held) return undefined;
    const left = since.current + minMs - Date.now();
    if (left <= 0) {
      setHeld(false);
      return undefined;
    }
    const id = window.setTimeout(() => setHeld(false), left);
    return () => window.clearTimeout(id);
  }, [flag, held, delayMs, minMs]);
  if (flag) return held;
  return held && minMs > 0 && Date.now() - since.current < minMs;
}
